// extracted by mini-css-extract-plugin
export default {"cropper":"styles_cropper__-bqqU","removeIcon":"styles_removeIcon__qqM6t"};